"use client"

import { CircleAlert, Plug } from "lucide-react"

export default function ExternalMCPMentionComponent({
  name,
  requiresReauthorization,
}: {
  name: string
  requiresReauthorization: boolean
}) {
  return (
    <span
      data-external-mcp-mention
      className="border-sand-300 bg-sand-100 text-sand-900 inline rounded-md border px-1 py-0.5 align-baseline text-sm leading-5 font-medium whitespace-nowrap"
    >
      <Plug className="text-sand-500 mr-1 inline size-[0.875em] align-[-0.125em]" />
      {requiresReauthorization && <CircleAlert className="text-red-accent mr-1 inline size-3.5 align-[-0.125em]" />}
      {name}
    </span>
  )
}
